// extracted by mini-css-extract-plugin
export default {"statusIndicator":"MapMarkers_statusIndicator__Jo-yD"};